import { TinyEmitter } from "tiny-emitter";

const EventBus = new TinyEmitter();

export default EventBus;
